import { render, staticRenderFns } from "./DxBinsTable.vue?vue&type=template&id=1f4f2721&"
import script from "./DxBinsTable.vue?vue&type=script&lang=js&"
export * from "./DxBinsTable.vue?vue&type=script&lang=js&"
import style0 from "./DxBinsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports